"use strict";

(function () {
    var t0 = new Date().getTime();
    var dTaction;

    // Add property so that global "console" is defined.  This prevents "use strict" errors in older IE.  
    // Specifically, durandal\system module looks for global console - if not defined, 
    // this will throw "console" not defined error in IE when "use strict" is enabled.
    // Instead of patching durandal, let's fix it here.
    if (!window.console) {
        window.console = {};
    }

    /***** START FRAMEWORK SPINUP *****/

    // SH46000 8/3/18 - Necessary because of IE 11.
    // Polyfill Promise if it is not available. 
    polyfillPromise();

    // Create global "fusion" object on window
    // and populate fusion properties.
    createFusionNamespace();
    populateFusionObject();

    // MODIFIED ** v6.0.1
    // We no longer require this whole file from the server, because the
    // r.js optimizer takes care of paths as it bundles. However, there are some
    // values in require.config that we need at runtime, so we set those here.
    loadRequireConfig()

    // ADDED ** v6.0.0
    // Register global error handlers
    registerErrorHandlers();

    // ADDED ** v6.0.0
    // Register callbacks that will run after FX has loaded.
    registerFusionLoadedCallbacks();

    // ADDED ** v6.0.0
    // This adds support for fusion globals that are configured 
    // server-side (initial use case involved getting Cordova flags
    // from a FusionApi installed with MobileExtension package).
    // We load in these globals and then chain together a series of
    // promise-based async tasks.
    loadFusionGlobals()

        // Point require to local resources if necessary.
        .then(normalizeRequireConfig)

        // Require FX setup modules, and intialize them in
        // a particular order.
        .then(getSetupModules)
        .then(startFw)


        .then(function () {
            var t1 = new Date().getTime();
            var log = require("fusion/log");    //safe to use synchronous syntax here because log module will have already been loaded by getSetupModules() above
            log.debug('Web framework initialization took : ' + (t1 - t0).toFixed(4) + 'milliseconds', "", "fusion-web-framework");
        });

    /***** END FRAMEWORK SPINUP *****/


    /**
     * Sends FX spinup errors to Dynatrace and console.
     */
    function handleError(err) {
        window.console && window.console.log && window.console.log(err);
    }


    /**
     * MODIFIED ** v6.0.1
     * We no longer require this whole file from the server, because the
     * r.js optimizer takes care of paths as it bundles. However, there are some
     * values in require.config that we need at runtime, so we set those here.
     */
    function loadRequireConfig() {
        require.config({

            // Increase wait to fix "module load timeout" errors
            waitSeconds: 220,

            // TODO ** v6.0.2
            // We may not need this now, as this was probably only
            // necessary to require files from cdn location. Leaving
            // it in for now just in case.
            //
            // Allow cross-domain requests, remote server allows CORS.
            config: {
                text: {
                    useXhr: function (url, protocol, hostname, port) {
                        return true;
                    }
                }
            }
        });
    };


    /**
     * ADDED ** v6.0.0
     * Gives a hook point for any actions that need to run after
     * fusion.ensureLoaded() has resolved.
     */
    function registerFusionLoadedCallbacks() {

        fusion.ensureLoaded().then(function () {

            // Remove fusion-fx-hidden class from DOM. On the server
            // side GetHeaderBlock() and GetFooterBlock() we set this class
            // and hide the elements, so that when the FX is done loading here
            // we can show those elements again. Fixes page styles flicker.
            fusion.isFoundationReady().then(function () {
                var $ = require("fusion/jquery");
                $(".fusion-fx-hidden").each(function () {
                    $(this).removeClass('fusion-fx-hidden').css('visibility', 'visible');
                });
            });


            // If in cordova scenario, add margin at the top for phone bar
            if (fusion.cordova.isCordova) {
                document.body.classList.add('fusion-cordova-body');
            }

        });
    }


    /**
     * MOVED ** v6.0.0
     * Moved from require-config.js file becuase this file is no 
     * longer required in, but is only used in the bundling.
     */
    function registerErrorHandlers() {
        // Set up global JS error handler
        window.onerror = function (msg, url, lineNo, columnNo, error) {
            require(["fusion/log"], function ($log) {
                try {
                    var string = msg.toLowerCase();
                    var substring = "script error";
                    if (error) {
                        $log.error(error);
                    }
                    else if (string.indexOf(substring) > -1) {
                        $log.error('Script Error: See Browser Console for Detail', url, "line: " + lineNo);
                    } else {
                        $log.error(msg, url, "line: " + lineNo);
                    }
                } catch (e) {
                    $log.error("Error in window.onerror: " + e.message);
                }
            });
            return false;
        };

        // Set up global RequireJS error handler
        requirejs.onError = function (err) {
            require(["fusion/log"], function ($log) {
                var msg = "";
                try {
                    msg = "RequireJS Error.\n\trequireType: " + err.requireType;
                    if (err.requireModules && err.requireModules.join) {
                        msg += "\n\trequireModules: " + err.requireModules.join(",");
                    }
                    msg += "\n\terr: " + err.toString();
                } catch (e) {
                    msg = "Error while handling  requirejs.onError: " + e.message
                }
                $log.error(msg);
            });
        };

        // Once FW has loaded Durandal, overwrite the system.error function so that we can send it to the server.
        // This needs to happen *after* the Durandal debug mode has been set to avoid losing our changes.
        fusion.ensureLoaded().then(function () {
            require(["durandal/system", "fusion/log"], function (system, $log) {
                system.error = function (error, err) {
                    try {
                        var exception;

                        if (error instanceof Error) {
                            exception = error;
                        } else {
                            exception = new Error(error);
                        }

                        if (err) {
                            exception.message += "  :: Inner Error: " + err;
                        }

                        $log.error(exception);
                    } catch (e) {
                        $log.error("Error in system.error: " + e.message);
                    }
                }
            });
        });
    }


    /**
     * Requires all the FX setup modules and resolves them
     * to the next promise in the chain.
     */
    function getSetupModules() {
        return new Promise(function (resolve, reject) {
            require([
                "fusion/setup/framework",
                "fusion/setup/durandal",
                "fusion/navigation",
                "fusion/applet"],
                function () {
                    resolve(arguments);
                }, reject);
        });
    }


    /**
     * MODIFIED ** v6.0.0
     * Here we initialize setup modules in a specific order.
     * For v6.0.0 we added a loadStyleFrameworks function to 
     * the framework setup module because of a timing/circular
     * dependency. We need to control the load order of styles
     * after the isEnterprise flag is pulled from $config.
     */
    function startFw(modules) {
        (function (framework, durandal, navigation, applet) {

            return framework.init()
                .then(framework.loadStyleFrameworks)
                .then(durandal.init)
                .then(navigation.init)
                .then(applet.processAppletTags)
                .then(framework.finalize);

        }).apply(this, modules);
    }


    /**
     * MODIFIED ** v6.0.0
     * Set any custom paths that requirejs needs when resolving module 
     * ID's. In v6.0.0 we moved away from prepending the fusioncdn path
     * and instead resolved modules to our local scripts path, where the
     * client package is installed.
     */
    function normalizeRequireConfig() {
        require.config({
            paths: {
                "css": fusion.scripts + "js/css",
                "css-build": fusion.scripts + "js/css-build",
                "fusion/ui/enterprise": fusion.scripts + "js/enterprise",
                "widgets": fusion.scripts + "js/widgets",
                "durandal/widgets": fusion.scripts + "js/widgets",
                "durandal/dialogs": fusion.scripts + "js/widgets/defaultDialog",
                "js/ext/kendo/styles": fusion.scripts + "css/kendo",
                "js/ext-css/jquery": fusion.scripts + "css/jquery",
                "js/ext/DataTables": fusion.scripts + "css/datatables",

            }
        });
    }


    /**
     * ADDED ** v6.0.0
     * Makes an ajax call to the server to load any server-side configs.
     */
    function loadFusionGlobals() {
        return new Promise(function (resolve, reject) {
            try {
                var promises = [];

                promises.push(loadGetFusionGlobals());
                promises.push(loadCordovaGlobals());
                promises.push(loadFusionExtensionClientPaths());

                Promise.all(promises).finally(resolve);
            } catch (ex) {
                resolve();
            }
        });
    }

    /**
     * ADDED ** v6.0.0
     * Makes an ajax call to our Core Api and sets up the fusion.globals object.
     */
    function loadGetFusionGlobals() {
        return new Promise(function (resolve, reject) {
            require(['fusion/jquery'], function ($) {

                $.ajax({
                    method: 'GET',
                    url: fusion.virtualpath + '/fusionapi/fusionCoreApi/GetFusionGlobals',
                    success: function (data) {
                        if (data && data.data) {
                            var results = data.data;
                            for (var property in results) {
                                if (results.hasOwnProperty(property)) {
                                    window.fusion.globals[property] = results[property];
                                }
                            }
                        }

                        resolve();
                    },
                    error: function (err) {
                        resolve();
                    }
                })
            });
        });
    }

    /**
     * ADDED ** v6.0.0
     * Loads cordova globals from fusion api.
     */
    function loadCordovaGlobals() {

        var cordovaModule = 'fusion-cordova-init';

        if (window.cordova) {
            return new Promise(function (resolve, reject) {

                require([cordovaModule], function (_cordova) {
                    _cordova.init().then(resolve);
                });
            });
        } else {
            return Promise.resolve();
        }
    }

    /**
     * ADDED ** v6.0.0
     * Calls the Fusion Core API and gets information on any extensions 
     * that are registered with the Framework. 
     */
    function loadFusionExtensionClientPaths() {
        return new Promise(function (resolve, reject) {
            require(['fusion/jquery'], function ($) {

                $.ajax({
                    method: 'GET',
                    url: fusion.virtualpath + '/fusionapi/fusionCoreApi/GetInstalledExtensionClientPaths',
                    success: function (data) {
                        if (data && data.data && data.data.length) {
                            var pkgs = data.data;

                            // Get registered extensions' require paths and module names and register
                            // them with requirejs. This allows extensions to register client-side files
                            // on application spinup so that we can require them from the client with
                            // only a simple key, which is also registered by the extension. 
                            // NOTE:
                            //   We have to use require.s.contexts here rather than just 
                            //   require.config() because the property names are dynamic.
                            var base = 'fusion/extensions/';
                            for (var i in pkgs) {
                                var pkg = pkgs[i];
                                require.s.contexts._.config.paths[base + pkg.key] = pkg.path;
                                if (pkg.entryPoint) {
                                    require.s.contexts._.config.paths[base + pkg.key + '/main'] = pkg.path + pkg.entryPoint;
                                }

                                if (pkg.runOnLoad) {

                                }
                            }

                            resolve();
                        } else {
                            resolve();
                        }
                    },
                    error: function (err) {
                        resolve();
                    }
                });
            });
        });
    }

    /**
     * Extends the window.fusion namespace, or else creates a new one.
     */
    function createFusionNamespace(cdn) {
        window.fusion = window.fusion || {};
    }


    /**
     * Populates the fusion namespace with FX level properties and functions.   
     */
    function populateFusionObject() {
        var fusion = window.fusion;

        // REMOVED ** v6.0.0
        // We no longer need a global fusion.cdn property,
        // as all modules and resources ares resolved either
        // in the bundle or else from our client package.
        fusion.cdn = "";

        // ADDED ** v6.0.0
        // We now expose a fusion.scripts path that points
        // to our client package install.
        fusion.scripts = getScriptsPath();

        // ADDED ** v6.0.1
        // We need this to make calls to FusionCoreApi for FX spinup. If the application
        // is hosted in a virtual directory, we need to prepend that to the api path.
        fusion.virtualpath = fusion.scripts.substring(0, fusion.scripts.indexOf("/App_Packages"));

        // ADDED ** v6.0.0
        // We can hold global config settings here from the Core API.
        fusion.globals = fusion.globals || {};

        // ADDED ** v6.0.0
        // Default value for our cordova settings, overwritten if
        // mobile package is installed.
        fusion.cordova = fusion.cordova || {};
        fusion.cordova.isCordova = false;

        // ADDED ** v6.0.0
        // Expose promsie on global object that lets us know
        // when foundation has been properly loaded.
        fusion.isFoundationReady = isFoundationReady;

        // This is a local-only password - can't be used to decrypt data coming from server
        fusion.teaKey = "fusionweb";

        // Default isLoaded to false. This will get set to true when framework.finalize() is called.
        fusion.isLoaded = false;
        fusion.ensureLoaded = ensureLoaded;

        fusion.cacheBusterKey = "";
        require.config({
            urlArgs: fusion.cacheBusterKey //set to initial value
        });



        // ADDED v6.0.4
        // Global offline settings
        //fusion.offline = fusion.offline || {};
        //fusion.isOnLine = navigator.onLine || false;            // ensuring at least some value here, but Fx setup makes this observable
        fusion.isOnline = null;            // ensuring at least some value here, but Fx setup makes this observable

     
    }


    /**
     * Global promise on the window.fusion namespace that
     * resolves when the framework is done loading.
     */
    function ensureLoaded() {
        return new Promise(function (resolve, reject) {
            waitForFrameworkToLoad(resolve);
        });
    }


    /**
     * Polls the framework every 100 milliseconds until 
     * the framework is done loading.
     */
    function waitForFrameworkToLoad(resolve) {
        if (!fusion.isLoaded) {
            setTimeout(waitForFrameworkToLoad.bind(this, resolve), 100);
        }
        else {
            var t2 = new Date().getTime();

            require(["fusion/log"], function (log) {
                log.debug('Web framework elapsed time to ensure loaded : ' + (t2 - t0).toFixed(4) + 'milliseconds', "", "fusion-web-framework");
                resolve();
            });

        }
    }


    /**
     * ADDED ** v6.0.0
     * Returns a promise that checks whether the foundation styles
     * exist yet on the page (script exists, and the request is no
     * longer pending). Optional checkGlobalInit function checks whether
     * $(document).foundation() has been called. 
     */
    function isFoundationReady(checkGlobalInit) {
        if (checkGlobalInit === null || checkGlobalInit === undefined) {
            checkGlobalInit = true;
        }

        var interval = 100;
        return new Promise(function (resolve, reject) {
            setTimeout(function cb() {
                var styles = document.styleSheets;
                for (var i = 0; i < styles.length; i++) {
                    if (styles[i].href &&
                        (styles[i].href.match("foundation")
                        || styles[i].href.match("scana-enterprise")
                        || styles[i].href.match("sceg-style")
                        || styles[i].href.match("psnc-style")
                        || styles[i].href.match("seb-style")
                        || styles[i].href.match("sebr-style"))) {
                        if (styles[i].cssRules != null && styles[i].cssRules.length > 0) {
                            if (checkGlobalInit) {
                                // SH46000
                                // Foundation.rtl is the only difference I could find in the Foundation
                                // object after $(document).foundation() is called. Even though it gets
                                // set to false, it doesn't even exist before this is called.
                                if (window.Foundation.rtl !== null && window.Foundation.rtl !== undefined) {
                                    resolve();
                                } else {
                                    return setTimeout(cb, interval);
                                }
                            } else {
                                resolve();
                            }
                        } else {
                            return setTimeout(cb, interval);
                        }
                    } else if (i == styles.length - 1) {
                        return setTimeout(cb, interval);
                    }
                }
            }, interval);
        });
    }


    /**
     * REMOVED ** v6.0.0
     * This is ignored in favor of the fusion scripts path below.
     * Finds CDN location/path.
     */
    function getCdn() {

        var fusionCdn;
        //configure require to use fusion cdn path
        eachReverse(scripts(), function (script) {
            var pattern = /\/js\/core\/fusion-web-framework(\-optimized)?.js(\?.*)?$/;
            var fusionCdnSrc = script.getAttribute('src');

            //check for null because in optimized version, some script tags
            //  are injected that do not have a `src` attribute.
            if (fusionCdnSrc) {

                //replace backslash, which works in some browsers, with appropriate forward slashes
                fusionCdnSrc = fusionCdnSrc.replace(/\\/g, "/");

                //if a match, then we know that fusionCdnSrc is the right script tag src
                if (fusionCdnSrc.match(pattern)) {

                    //now we have the CDN location
                    fusionCdn = fusionCdnSrc.replace(pattern, "");

                    return true;    //return true so that eachReverse quits iterating
                }
            }
        });

        return fusionCdn;
    }


    /**
     * ADDED ** v6.0.0
     * Gets the path for where the FX scripts are kept on the server
     * by look at the script tag for the optimized FX bundle.
     */
    function getScriptsPath() {

        var fusionScripts;
        eachReverse(scripts(), function (script) {
            //var pattern = /\/fusion-web-framework(\-optimized)?.js(\?.*)?$/;

            // SH46000 - 8/2/18
            // Had to append the js here now that we nest the core fx scripts inside the /js folder.
            var pattern = /\/js\/fusion-web-framework(\-optimized)?.js(\?.*)?$/;
            var fusionScriptsSrc = script.getAttribute('src');

            // Check for null because in optimized version, some script tags
            // are injected that do not have a `src` attribute.
            if (fusionScriptsSrc) {

                // Replace backslash, which works in some browsers, with appropriate forward slashes
                fusionScriptsSrc = fusionScriptsSrc.replace(/\\/g, "/");

                // If a match, then we know that fusionScriptsSrc is the right script tag src
                if (fusionScriptsSrc.match(pattern)) {

                    // Now we have the scripts location
                    fusionScripts = fusionScriptsSrc.replace(pattern, "");

                    // Return true so that eachReverse quits iterating
                    return true;
                }
            }
        });

        return fusionScripts + "/";
    }


    /**
     * Helper function that returns any script tags in the document.
     */
    function scripts() {
        return document.getElementsByTagName('script');
    }


    /**
     * Helper function for iterating over an array. If the func returns
     * a true value, it will break out of the loop.
     */
    function each(ary, func) {
        if (ary) {
            var i;
            for (i = 0; i < ary.length; i += 1) {
                if (ary[i] && func(ary[i], i, ary)) {
                    break;
                }
            }
        }
    }


    /**
     * Helper function for iterating over an array backwards. If the func
     * returns a true value, it will break out of the loop.
     */
    function eachReverse(ary, func) {
        if (ary) {
            var i;
            for (i = ary.length - 1; i > -1; i -= 1) {
                if (ary[i] && func(ary[i], i, ary)) {
                    break;
                }
            }
        }
    }


    /**
     * Provides a Promise polyfill for compatibility with older browsers.
     */
    function polyfillPromise() {
        //!function (a) { function b(a, b) { return function () { a.apply(b, arguments) } } function c(a) { if ("object" != typeof this) throw new TypeError("Promises must be constructed via new"); if ("function" != typeof a) throw new TypeError("not a function"); this._state = null, this._value = null, this._deferreds = [], i(a, b(e, this), b(f, this)) } function d(a) { var b = this; return null === this._state ? void this._deferreds.push(a) : void j(function () { var c = b._state ? a.onFulfilled : a.onRejected; if (null === c) return void (b._state ? a.resolve : a.reject)(b._value); var d; try { d = c(b._value) } catch (e) { return void a.reject(e) } a.resolve(d) }) } function e(a) { try { if (a === this) throw new TypeError("A promise cannot be resolved with itself."); if (a && ("object" == typeof a || "function" == typeof a)) { var c = a.then; if ("function" == typeof c) return void i(b(c, a), b(e, this), b(f, this)) } this._state = !0, this._value = a, g.call(this) } catch (d) { f.call(this, d) } } function f(a) { this._state = !1, this._value = a, g.call(this) } function g() { for (var a = 0, b = this._deferreds.length; b > a; a++) d.call(this, this._deferreds[a]); this._deferreds = null } function h(a, b, c, d) { this.onFulfilled = "function" == typeof a ? a : null, this.onRejected = "function" == typeof b ? b : null, this.resolve = c, this.reject = d } function i(a, b, c) { var d = !1; try { a(function (a) { d || (d = !0, b(a)) }, function (a) { d || (d = !0, c(a)) }) } catch (e) { if (d) return; d = !0, c(e) } } var j = c.immediateFn || "function" == typeof setImmediate && setImmediate || function (a) { setTimeout(a, 1) }, k = Array.isArray || function (a) { return "[object Array]" === Object.prototype.toString.call(a) }; c.prototype["catch"] = function (a) { return this.then(null, a) }, c.prototype.then = function (a, b) { var e = this; return new c(function (c, f) { d.call(e, new h(a, b, c, f)) }) }, c.all = function () { var a = Array.prototype.slice.call(1 === arguments.length && k(arguments[0]) ? arguments[0] : arguments); return new c(function (b, c) { function d(f, g) { try { if (g && ("object" == typeof g || "function" == typeof g)) { var h = g.then; if ("function" == typeof h) return void h.call(g, function (a) { d(f, a) }, c) } a[f] = g, 0 === --e && b(a) } catch (i) { c(i) } } if (0 === a.length) return b([]); for (var e = a.length, f = 0; f < a.length; f++) d(f, a[f]) }) }, c.resolve = function (a) { return a && "object" == typeof a && a.constructor === c ? a : new c(function (b) { b(a) }) }, c.reject = function (a) { return new c(function (b, c) { c(a) }) }, c.race = function (a) { return new c(function (b, c) { for (var d = 0, e = a.length; e > d; d++) a[d].then(b, c) }) }, "undefined" != typeof module && module.exports ? module.exports = c : a.Promise || (a.Promise = c) }(window);

        // https://github.com/taylorhakes/promise-polyfill
        // MODIFIED ** 6.0.2
        // SH46000 - Had to slightly modify the polyfill. Don't need the define()
        // calls, as they interfere with requirejs and error out.
        !function (e, n) {/*"object"==typeof exports&&"undefined"!=typeof module?n():"function"==typeof define&&define.amd?define(n):n()*/n(); }(0, function () { "use strict"; function e(e) { var n = this.constructor; return this.then(function (t) { return n.resolve(e()).then(function () { return t }) }, function (t) { return n.resolve(e()).then(function () { return n.reject(t) }) }) } function n() { } function t(e) { if (!(this instanceof t)) throw new TypeError("Promises must be constructed via new"); if ("function" != typeof e) throw new TypeError("not a function"); this._state = 0, this._handled = !1, this._value = undefined, this._deferreds = [], u(e, this) } function o(e, n) { for (; 3 === e._state;) e = e._value; 0 !== e._state ? (e._handled = !0, t._immediateFn(function () { var t = 1 === e._state ? n.onFulfilled : n.onRejected; if (null !== t) { var o; try { o = t(e._value) } catch (f) { return void i(n.promise, f) } r(n.promise, o) } else (1 === e._state ? r : i)(n.promise, e._value) })) : e._deferreds.push(n) } function r(e, n) { try { if (n === e) throw new TypeError("A promise cannot be resolved with itself."); if (n && ("object" == typeof n || "function" == typeof n)) { var o = n.then; if (n instanceof t) return e._state = 3, e._value = n, void f(e); if ("function" == typeof o) return void u(function (e, n) { return function () { e.apply(n, arguments) } }(o, n), e) } e._state = 1, e._value = n, f(e) } catch (r) { i(e, r) } } function i(e, n) { e._state = 2, e._value = n, f(e) } function f(e) { 2 === e._state && 0 === e._deferreds.length && t._immediateFn(function () { e._handled || t._unhandledRejectionFn(e._value) }); for (var n = 0, r = e._deferreds.length; r > n; n++) o(e, e._deferreds[n]); e._deferreds = null } function u(e, n) { var t = !1; try { e(function (e) { t || (t = !0, r(n, e)) }, function (e) { t || (t = !0, i(n, e)) }) } catch (o) { if (t) return; t = !0, i(n, o) } } var c = setTimeout; t.prototype["catch"] = function (e) { return this.then(null, e) }, t.prototype.then = function (e, t) { var r = new this.constructor(n); return o(this, new function (e, n, t) { this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof n ? n : null, this.promise = t }(e, t, r)), r }, t.prototype["finally"] = e, t.all = function (e) { return new t(function (n, t) { function o(e, f) { try { if (f && ("object" == typeof f || "function" == typeof f)) { var u = f.then; if ("function" == typeof u) return void u.call(f, function (n) { o(e, n) }, t) } r[e] = f, 0 == --i && n(r) } catch (c) { t(c) } } if (!e || "undefined" == typeof e.length) throw new TypeError("Promise.all accepts an array"); var r = Array.prototype.slice.call(e); if (0 === r.length) return n([]); for (var i = r.length, f = 0; r.length > f; f++) o(f, r[f]) }) }, t.resolve = function (e) { return e && "object" == typeof e && e.constructor === t ? e : new t(function (n) { n(e) }) }, t.reject = function (e) { return new t(function (n, t) { t(e) }) }, t.race = function (e) { return new t(function (n, t) { for (var o = 0, r = e.length; r > o; o++) e[o].then(n, t) }) }, t._immediateFn = "function" == typeof setImmediate && function (e) { setImmediate(e) } || function (e) { c(e, 0) }, t._unhandledRejectionFn = function (e) { void 0 !== console && console && console.warn("Possible Unhandled Promise Rejection:", e) }; var l = function () { if ("undefined" != typeof self) return self; if ("undefined" != typeof window) return window; if ("undefined" != typeof global) return global; throw Error("unable to locate global object") }(); "Promise" in l ? l.Promise.prototype["finally"] || (l.Promise.prototype["finally"] = e) : l.Promise = t });
    }
})();

define("js/core/fusion-web-framework", function(){});

